import React from 'react';
import {
  Box,
  Typography,
  Button,
  Stack,
  Badge
} from '@mui/material';
import {
  Download as DownloadIcon,
  Refresh as RefreshIcon
} from '@mui/icons-material';

interface PayrollHeaderProps {
  selectedPayrolls: number[];
  onBulkActionsClick: () => void;
  onExportClick: () => void;
  onRefresh: () => void;
  loading: boolean;
}

export const PayrollHeader: React.FC<PayrollHeaderProps> = ({
  selectedPayrolls,
  onBulkActionsClick,
  onExportClick,
  onRefresh,
  loading
}) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
        <Typography variant="h4" component="h1" fontWeight="bold">
          Payroll Management
        </Typography>
        <Stack direction="row" spacing={2}>
          <Button
            variant="outlined"
            startIcon={<Badge badgeContent={selectedPayrolls.length} color="primary"><span /></Badge>}
            onClick={onBulkActionsClick}
            disabled={selectedPayrolls.length === 0}
          >
            Bulk Actions ({selectedPayrolls.length})
          </Button>
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={onExportClick}
          >
            Export
          </Button>
          <Button
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={onRefresh}
            disabled={loading}
          >
            Refresh
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};
